import { Buffer } from 'buffer'

import React from 'react'

import dayjs from 'dayjs'
import { createRoot } from 'react-dom/client'
import { pdfjs } from 'react-pdf'

import App from './App'
import { IS_MOCK_MODE } from './constants/featureFlag'
import { redirectFromLogoutComplete } from './features/auth/utils/redirectFromLogoutComplete'
import { initialize as initializeAmplify } from './lib/aws-amplify'
import { initialize as initializeDatadog } from './lib/datadog'
import { initialize as initializeSentry } from './lib/sentry'
import './global.css'
import { worker as MockServiceWorker } from './tests/mocks/browser'

import 'dayjs/locale/ja'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString()

dayjs.locale('ja')
globalThis.Buffer = Buffer

const bootstrap = () => {
  initializeSentry()
  initializeDatadog()
  initializeAmplify()

  if (IS_MOCK_MODE) {
    MockServiceWorker.start()
  }

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

// ログアウトの中継画面はAuth0へ遷移するだけなので、アプリを起動せずにリダイレクトする。
if (!redirectFromLogoutComplete()) {
  bootstrap()
}
